import { allServices } from "./services";

export const generateEmptyTile = (productType: string) => ({
  available: true,
  productType,
  url: allServices[productType].url,
  loading: false,
  actionButtonText: "Global.MoreInfo",
});
